import { useCallback, useRef } from 'react';
export type ImperativeDialogRef = {
  open: () => void;
  close: () => void;
};

export default function useImperativeDialogRef() {
  const ref = useRef<ImperativeDialogRef>(null);
  const open = useCallback(() => {
    ref.current?.open?.();
  }, []);
  const close = useCallback(() => {
    ref.current?.close?.();
  }, []);

  return { ref, open, close };
}
